/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetDataConnectionInfoForDataSourceTooltipQueryVariables =
  Types.Exact<{
    dataConnectionId: Types.Scalars["DataConnectionId"]["input"];
  }>;

export type GetDataConnectionInfoForDataSourceTooltipQuery = {
  readonly __typename: "Query";
  readonly dataConnectionById: {
    readonly __typename: "DataConnection";
    readonly id: c.DataConnectionId;
    readonly connectionType: c.DataConnectionType;
    readonly isMultiDatabase: boolean;
  };
};

export const GetDataConnectionInfoForDataSourceTooltipDocument = /*#__PURE__*/ gql`
  query GetDataConnectionInfoForDataSourceTooltip(
    $dataConnectionId: DataConnectionId!
  ) {
    dataConnectionById(dataConnectionId: $dataConnectionId) {
      id
      connectionType
      isMultiDatabase
    }
  }
`;

/**
 * __useGetDataConnectionInfoForDataSourceTooltipQuery__
 *
 * To run a query within a React component, call `useGetDataConnectionInfoForDataSourceTooltipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataConnectionInfoForDataSourceTooltipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataConnectionInfoForDataSourceTooltipQuery({
 *   variables: {
 *      dataConnectionId: // value for 'dataConnectionId'
 *   },
 * });
 */
export function useGetDataConnectionInfoForDataSourceTooltipQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDataConnectionInfoForDataSourceTooltipQuery,
    GetDataConnectionInfoForDataSourceTooltipQueryVariables
  > &
    (
      | {
          variables: GetDataConnectionInfoForDataSourceTooltipQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDataConnectionInfoForDataSourceTooltipQuery,
    GetDataConnectionInfoForDataSourceTooltipQueryVariables
  >(GetDataConnectionInfoForDataSourceTooltipDocument, options);
}
export function useGetDataConnectionInfoForDataSourceTooltipLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDataConnectionInfoForDataSourceTooltipQuery,
    GetDataConnectionInfoForDataSourceTooltipQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDataConnectionInfoForDataSourceTooltipQuery,
    GetDataConnectionInfoForDataSourceTooltipQueryVariables
  >(GetDataConnectionInfoForDataSourceTooltipDocument, options);
}
export function useGetDataConnectionInfoForDataSourceTooltipSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDataConnectionInfoForDataSourceTooltipQuery,
    GetDataConnectionInfoForDataSourceTooltipQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDataConnectionInfoForDataSourceTooltipQuery,
    GetDataConnectionInfoForDataSourceTooltipQueryVariables
  >(GetDataConnectionInfoForDataSourceTooltipDocument, options);
}
export type GetDataConnectionInfoForDataSourceTooltipQueryHookResult =
  ReturnType<typeof useGetDataConnectionInfoForDataSourceTooltipQuery>;
export type GetDataConnectionInfoForDataSourceTooltipLazyQueryHookResult =
  ReturnType<typeof useGetDataConnectionInfoForDataSourceTooltipLazyQuery>;
export type GetDataConnectionInfoForDataSourceTooltipSuspenseQueryHookResult =
  ReturnType<typeof useGetDataConnectionInfoForDataSourceTooltipSuspenseQuery>;
export type GetDataConnectionInfoForDataSourceTooltipQueryResult =
  Apollo.QueryResult<
    GetDataConnectionInfoForDataSourceTooltipQuery,
    GetDataConnectionInfoForDataSourceTooltipQueryVariables
  >;
